import styled from "styled-components";

const Main = styled.main`
    margin-top: 80px;
`;

export { Main }